import {
  jb_newsletter_registration_form_css_default
} from "./chunk.NHFGCOCM.js";
import {
  JbPopup
} from "./chunk.MZC2L2IN.js";
import {
  ae
} from "./chunk.RIMVGMXQ.js";
import {
  Spaceable
} from "./chunk.P6YYTXAQ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  JBCookie
} from "./chunk.VQ52AZAH.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n,
  r as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-newsletter-registration-form/jb-newsletter-registration-form.ts
var stickyCookieName = "jbNlReg";
var stickyWaitTime = 20 * 1e3;
var JbNewsletterRegistrationForm = class extends Spaceable(r) {
  constructor() {
    super(...arguments);
    this.ARIALABELS_DEFAULT = {
      close: "Close"
    };
    this.forceInstantly = false;
    this.formAction = "";
    this.headline = "";
    this.subline = "";
    this.successText = "";
    this.type = "default";
    this._formOpenTrackedSticky = false;
    this._formSent = false;
    this._formValid = false;
    this._lastFocusedElement = null;
  }
  firstUpdated() {
    if (this.type === "sticky") {
      this._inputField.addEventListener("focusin", () => {
        this._expandStickyContainer();
      });
      setTimeout(() => {
        const newsletterRegistrationCookieValue = JBCookie.getCookie(stickyCookieName);
        if (newsletterRegistrationCookieValue) {
          return;
        }
        const agreementText = this.renderRoot.querySelector("jb-richtext.agreementText");
        const checkbox = this.renderRoot.querySelector("jb-checkbox");
        const button = this.renderRoot.querySelector("jb-button-primary");
        let paddingAdjustment = window.matchMedia("(min-width: 367px)").matches ? 38 : 58;
        paddingAdjustment = window.matchMedia("(min-width: 1281px)").matches ? 61 : paddingAdjustment;
        this._unexpandListener = this._unexpand.bind(this);
        document.addEventListener("click", this._unexpandListener);
        this.style.setProperty(
          "--_scrolloutheight",
          `${(checkbox ? checkbox.offsetHeight : 0) + (agreementText ? agreementText.offsetHeight : 0) + button.offsetHeight + paddingAdjustment}px`
        );
        this._formWrapper.classList.add("show");
        this._lastFocusedElement = this._getLastFocusedElement();
        this.renderRoot.querySelector(".sticky").removeAttribute("inert");
        if (document.querySelector("jb-focus-fly")?._isVisible()) {
          const elementToFocus = this.renderRoot.querySelector("input");
          elementToFocus.focus();
          this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        }
      }, stickyWaitTime);
    }
    this.addEventListener("jb-tracking", (e2) => {
      const customEvent = e2;
      if (customEvent.detail?.event === "ce_form") {
        customEvent.detail.component_name = this.type === "sticky" ? "newsletter-registration-form" : "article-tool-bar";
        customEvent.detail.form_subject = "newsletter";
      }
      if (customEvent.detail?.event === "ce_form" && customEvent.detail?.form_step_name === "form open") {
        customEvent.stopPropagation();
        this._formOpenEvent = customEvent;
      }
    });
  }
  static open(evt) {
    const newsletterRegistrationNode = document.querySelector(
      'jb-newsletter-registration-form[type="popup"]'
    );
    if (!newsletterRegistrationNode) {
      return;
    }
    const newsletterRegistrationWrapper = newsletterRegistrationNode.shadowRoot?.firstElementChild;
    if (!newsletterRegistrationWrapper) {
      return;
    }
    newsletterRegistrationWrapper.style.display = "block";
    const clone = newsletterRegistrationNode.cloneNode(true);
    newsletterRegistrationNode.parentNode.appendChild(clone);
    new JbPopup().init({
      props: {
        animates: true,
        returnFocusTo: evt.detail.returnFocusTo,
        ariaLabels: evt.detail.ariaLabels || {
          label: newsletterRegistrationNode.headline
        }
      },
      childNodes: [newsletterRegistrationNode]
    }).stack();
    document.body.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_form",
          event_version: "v2",
          component_name: "article-tool-bar",
          form_component: newsletterRegistrationNode.shadowRoot?.querySelector("jb-form"),
          form_step_name: "form open",
          form_step_nr: "1",
          form_subject: "newsletter registration",
          form_type: "newsletter"
        },
        bubbles: true,
        composed: true
      })
    );
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    }, 150);
  }
  _captureTracking(evt) {
    evt.stopPropagation();
    if (this.type === "default") {
      this._trackFormOpen("newsletter-registration-form");
    }
  }
  _expandStickyContainer() {
    this._formWrapper.classList.add("expanded");
    if (!this._formOpenTrackedSticky) {
      this._trackFormOpen("sticky-newsletter");
      this._formOpenTrackedSticky = true;
    }
    setTimeout(() => {
      this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    }, 350);
  }
  _getContentSpacingProperties() {
    return { colsMdUp: 10, grid: true };
  }
  _getLastFocusedElement() {
    let elm = document.activeElement;
    while (elm && elm.shadowRoot) {
      elm = elm.shadowRoot.activeElement;
    }
    return elm;
  }
  _handleCloseIconClick() {
    if (this.type === "sticky") {
      this._formWrapper.classList.remove("show");
      this._formWrapper.classList.remove("expanded");
      JBCookie.setCookie(stickyCookieName, "1", 182);
      document.removeEventListener("click", this._unexpandListener);
      this._lastFocusedElement?.focus();
      this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
      this.renderRoot.querySelector(".sticky").setAttribute("inert", "");
    }
    if (this.type === "popup") {
      document.querySelector("jb-popup")?.unstack();
    }
  }
  _submit() {
    const form = this._formWrapper.querySelector("jb-form");
    const slottedInputs = form.querySelectorAll("jb-text-field, jb-checkbox");
    const additionalInputs = form.shadowRoot?.querySelectorAll("input");
    const formData = {};
    let isValid = true;
    Array.from([...slottedInputs, ...additionalInputs || []]).forEach((element) => {
      try {
        if (element.validate) {
          isValid = element.validate() && isValid;
        }
        const name = element.getAttribute("name");
        formData[name] = element.value;
        if (element.tagName === "JB-CHECKBOX") {
          formData[name] = element.checkbox?.checked;
        } else {
          formData[name] = element.value;
        }
      } catch (err) {
      }
    });
    this._formValid = isValid;
    if (!isValid) {
      return;
    }
    if (this.agreementFieldName in formData) {
      formData.first_party_data_processing = true;
    }
    formData.source = this.type;
    form.classList.add("is-muted");
    if (this.submissionMode === "fetch") {
      fetch(this.formAction, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        redirect: "follow",
        body: JSON.stringify(formData)
      }).then((response) => {
        if (!response.ok) {
          this._formSent = true;
          this.updateComplete.then(() => {
            this._formError.classList.toggle("is-hidden");
            form.classList.remove("is-muted");
          });
        }
        return response.json();
      }).then((data) => {
        if (data.success === true) {
          this._formSent = true;
          this.updateComplete.then(() => {
            this._formSuccess.classList.toggle("is-hidden");
            form.classList.toggle("is-hidden");
          });
        }
      }).then(() => {
        setTimeout(() => {
          this._handleCloseIconClick();
        }, 3e3);
      });
    }
  }
  _trackFormOpen(componentName) {
    document.body.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_form",
          event_version: "v2",
          component_name: componentName,
          form_component: this._form,
          form_step_name: "form open",
          form_step_nr: "1",
          form_subject: "newsletter registration",
          form_type: "newsletter"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _unexpand(evt) {
    if (evt.target.nodeName === "JB-NEWSLETTER-REGISTRATION-FORM" || !this._formWrapper.classList.contains("expanded"))
      return;
    this._formWrapper.classList.remove("expanded");
    this._lastFocusedElement?.focus();
    this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    this._lastFocusedElement = void 0;
  }
  render() {
    return ke`
      <div
        class="newsletter-registration-form ${this.type}"
        ?inert=${this.type === "sticky"}
        @keydown=${(evt) => {
      if (evt.code === "Escape" || evt.key === "Escape") {
        if (this.type === "sticky") {
          this._unexpand(evt);
        } else if (this.type === "popup") {
          this._handleCloseIconClick();
        }
      }
    }}
        @focusin=${() => {
      if (this.type === "sticky") {
        this._expandStickyContainer();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true }));
      }
    }}
        @focusout=${(evt) => {
      if (this.type === "sticky") {
        const target = evt.relatedTarget;
        if (target && target.closest(".sticky")) {
          return;
        }
        this._unexpand(evt);
      }
    }}
      >
        <div class="form-wrapper">
          <div class="form-container">
            <div class="content-container">
              ${this.headline ? ke`<jb-section-headline .headline=${this.headline}></jb-section-headline>` : D}
              ${this.subline ? ke`<h4>${this.subline}</h4>` : D}
            </div>
            ${this.type === "sticky" || this.type === "popup" ? ke`<button
                  class="close-button"
                  @click=${this._handleCloseIconClick}
                  @keydown=${(evt) => {
      if (evt.code === "Enter" || evt.key === "Space") {
        this._handleCloseIconClick();
      }
    }}
                  data-flyCatcher
                  aria-label=${this.ariaLabels?.close || this.ARIALABELS_DEFAULT.close}
                >
                  <jb-close-icon></jb-close-icon>
                </button>` : D}
            ${!this._formSent ? ke`<jb-form
                  novalidate
                  .action=${this.formAction}
                  method="post"
                  .displayGrid=${false}
                  .additionalData=${this.formAdditionalData}
                  trackingSubject="newsletter-registration-form"
                  @jb-form:submit=${(e2) => {
      if (this.formAction !== "") {
        e2.detail.preventDefault();
      }
    }}
                  @jb-tracking=${this._captureTracking}
                >
                  <jb-text-field
                    .emailErrorText=${this.emailFieldData?.emailErrorText}
                    .type=${this.emailFieldData.type}
                    name=${this.emailFieldData.name}
                    ?isWhite=${this.type === "sticky" || this.type === "popup"}
                    .placeholder=${this.emailFieldData.placeholder}
                    .label=${this.emailFieldData.label}
                    .requiredText=${this.emailFieldData.emailErrorText}
                  >
                  </jb-text-field>
                  ${ke`
                    <jb-checkbox
                      .afterCheckboxText=${this.afterCheckboxText}
                      .beforeCheckboxText=${this.beforeCheckboxText}
                      .label=${this.agreement}
                      ?isWhite=${this.type === "sticky" || this.type === "popup"}
                      name=${this.agreementFieldName}
                      .required=${this.agreementRequiredText ? true : D}
                      .requiredText=${this.agreementRequiredText}
                      value="accepted"
                    >
                    </jb-checkbox>
                  `}
                  <jb-button-primary
                    name="submit"
                    formName="Newsletter Registration Form"
                    componentName="newsletter-registration-form"
                    @click=${this._submit}
                    ?inverted=${this.type !== "default"}
                    >${this.subscribeBtn.text}</jb-button-primary
                  >
                </jb-form>` : ke`<div class="form-errors">
                  <div class="form-error is-hidden">
                    <jb-richtext>${ae(this.errorText)}</jb-richtext>
                  </div>
                  <div class="form-success is-hidden">
                    <jb-checkmark-icon></jb-checkmark-icon><jb-richtext>${ae(this.successText)}</jb-richtext>
                  </div>
                </div>`}
          </div>
        </div>
      </div>
    `;
  }
};
JbNewsletterRegistrationForm.styles = jb_newsletter_registration_form_css_default;
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "afterCheckboxText", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "agreement", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "agreementFieldName", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "agreementRequiredText", 2);
__decorateClass([
  n({ type: Object })
], JbNewsletterRegistrationForm.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "beforeCheckboxText", 2);
__decorateClass([
  n({ type: Object })
], JbNewsletterRegistrationForm.prototype, "emailFieldData", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "errorText", 2);
__decorateClass([
  n({ type: Boolean })
], JbNewsletterRegistrationForm.prototype, "forceInstantly", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "formAction", 2);
__decorateClass([
  n({ type: Object })
], JbNewsletterRegistrationForm.prototype, "formAdditionalData", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "headline", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "subline", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "submissionMode", 2);
__decorateClass([
  n({ type: Object })
], JbNewsletterRegistrationForm.prototype, "subscribeBtn", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "successText", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "type", 2);
__decorateClass([
  e("jb-form")
], JbNewsletterRegistrationForm.prototype, "_form", 2);
__decorateClass([
  e(".form-error")
], JbNewsletterRegistrationForm.prototype, "_formError", 2);
__decorateClass([
  r2()
], JbNewsletterRegistrationForm.prototype, "_formSent", 2);
__decorateClass([
  e(".form-success")
], JbNewsletterRegistrationForm.prototype, "_formSuccess", 2);
__decorateClass([
  e(".newsletter-registration-form")
], JbNewsletterRegistrationForm.prototype, "_formWrapper", 2);
__decorateClass([
  e("jb-text-field")
], JbNewsletterRegistrationForm.prototype, "_inputField", 2);
__decorateClass([
  r2()
], JbNewsletterRegistrationForm.prototype, "_lastFocusedElement", 2);
JbNewsletterRegistrationForm = __decorateClass([
  customElement("jb-newsletter-registration-form")
], JbNewsletterRegistrationForm);
document.addEventListener("jbNewsletterOverlayPopupOpen", JbNewsletterRegistrationForm.open);

export {
  JbNewsletterRegistrationForm
};
